module.exports = __webpack_public_path__ + "assets/media/arrow-top.8aead7e1.svg";